var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 9V12.63C33 15 31.5 16.5 29.13 16.5H24V6.015C24 4.35 25.365 3 27.03 3C28.665 3.015 30.165 3.675 31.245 4.755C32.325 5.85 33 7.35 33 9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5V31.5C3 32.745 4.40996 33.45 5.39996 32.7L7.965 30.78C8.565 30.33 9.40501 30.39 9.94501 30.93L12.435 33.435C13.02 34.02 13.98 34.02 14.565 33.435L17.085 30.915C17.61 30.39 18.45 30.33 19.035 30.78L21.6 32.7C22.59 33.435 24 32.73 24 31.5V6C24 4.35 25.35 3 27 3H10.5H9C4.5 3 3 5.685 3 9V10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 19.5H16.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.2bfaffb180c5c8a9d75e520a3631c3cf.svg";
export { ForwardRef as ReactComponent };